import { useGetDisputData } from '@/features/orders/hooks/useGetDisputData'
import { DisputBlock } from '@/features/orders/ui/Order/DisputBlock/DisputBlock'
import { PayoutHeader } from '@/features/withdraws'
import { useWithdrawData } from '@/features/withdraws/hooks/useWithdrawData'
import { BasePageSkeleton } from '@/shared/components'
import { BaseBanner } from '@/shared/components/BaseBanner/BaseBanner'
import { useEffect } from 'react'

export const PayoutPage = () => {
  const {
    data,
    error,
    isLoading,
    rubAmount,
    usdtAmount,
    infoBlock1,
    infoBlock2,
    rubFactAmount,
    usdtFactAmount,
  } = useWithdrawData()

  const { disputData } = useGetDisputData({
    disputId: data?.disputId ?? '',
  })

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  if (isLoading) {
    return (
      <>
        <BasePageSkeleton />
      </>
    )
  }

  if (data) {
    return (
      <div className="flex flex-col gap-[30px] md:gap-8">
        <PayoutHeader
          data={data}
          currencyRub={rubAmount}
          currencyUsdt={usdtAmount}
          currencyRubFact={rubFactAmount}
          currencyUsdtFact={usdtFactAmount}
        />
        <BaseBanner info={infoBlock1} currencyRub={rubAmount} currencyUsdt={usdtAmount} />
        <BaseBanner info={infoBlock2} />
        {disputData && data?.disputId && <DisputBlock disput={disputData} />}
        {/* <BaseBanner info={infoBlock3} direction="col" /> Мерчант не должен видеть чеки */}
      </div>
    )
  }

  if (error) {
    return (
      <>
        <p>Ошибка загрузки данных</p>
      </>
    )
  }
}
